<form #kvForm="ngForm" name="kvForm" class="form">
    <table class="table table-condensed table-hover" style="table-layout:fixed">
        <thead>
        <tr>
            <th>{{LOCALIZATION.libraryName}}</th>
            <th>
                <label class="control control--checkbox" style="display:inline; margin-bottom:0px;">
                     <input 
                     	type="checkbox" 
                     	[(ngModel)]="all_libraries" 
                     	id="alllibs" 
                     	name="alllibs" 
                     	(change)="toggleAllLibraries()" 
                     	aria-label="Enable all libraries" />
                     <div class="control__indicator"></div>
                 </label>
                 <span>{{LOCALIZATION.librariesAll}}</span>
             </th>
         </tr>
         </thead>
         <tbody>
         <tr *ngFor="let lib of libraryPrefs">
             <td>
                 <input 
                 	type="text" 
                 	[(ngModel)]='lib.displayName' 
                 	[id]="lib.name" 
                 	[name]="lib.name" 
                 	class="form-control" 
                 	placeholder="{{LOCALIZATION.libraryName}}" 
                 	required />               	
             </td>
             <td class="text-center">
                 <label class="control control--checkbox">
                     <input 
                     	type="checkbox" 
                     	[(ngModel)]="lib.isAvailable" 
                     	(click)="checkAllLibraries()" 
	                 	[id]="'available_' + lib.name"
	                 	[name]="'available_' + lib.name"                   	
                     	[attr.aria-label]="lib.displayName + ' is enabled'" />
                     <div class="control__indicator"></div>
                 </label>
             </td>
         </tr>
         </tbody>
     </table>
	 <br>
	 <button 
		(click)="updateLibraries()"
		[disabled]="!kvForm.valid"
		type="submit" 
		class="btn btn-primary pull-right" 
		title="{{LOCALIZATION.update}}">
			{{LOCALIZATION.update}}
	 </button>        
 </form>
